import { Injectable, NgZone } from '@angular/core';
import { Globals } from '../../app.globals';
import { Client } from 'elasticsearch';
import * as _ from 'lodash';
import { BasicSearchParams } from './search.service';

@Injectable()
export class ES {
    private es: Client;
    private esurl: string = "";
    private size: number = 20;
    private from: number = 0;

    constructor(private ngZone: NgZone) {
        this.es = new Client({ 'host': new Globals().esEndpoint });
        this.esurl = new Globals().esEndpoint;
    }



    search(searchParams: any) {

        return Promise.resolve(this.es.search(searchParams).then(
            function (data) {
                return data;
            }
        ));

    }

    getSearchCriteriaByIndexType(type, q) {
        let options: any = {};
        options.type = type;
        options = {
            index: 'newone_weget',
            _source: ['_id'],
            type: type,
            body: {
                size: this.size,
                from: this.from,
                fields: ['domain'],
                'query': {
                    'filtered': {
                        'query': {
                            'match_all': {}
                        },
                        'filter': {}
                    }
                }
            }
        };

        if (typeof options.body.query.filtered.filter.bool === 'undefined') {
            options.body.query.filtered.filter.bool = {};
        }
        if (typeof options.body.query.filtered.filter.bool.must === 'undefined') {
            options.body.query.filtered.filter.bool.must = [];
        }
        if (typeof options.body.query.filtered.filter.bool.must_not === 'undefined') {
            options.body.query.filtered.filter.bool.must_not = [];
        }
        if (type === 'song') {
            options.body.query.filtered.filter.bool.must.push({ term: { 'active': '1' } });
            options.body.query.filtered.filter.bool.must.push({ 'exists': { 'field': 'approved_at' } });
            options.body.query.filtered.filter.bool.must.push({ 'range': { 'length': { 'gte': 120 } } });
            options.body.query.filtered.filter.bool.must_not.push({ term: { 'pricing': 'A' } });
            options.body.query.filtered.filter.bool.must_not.push({ 'match_phrase_prefix': { 'genres.name': { 'query': 'Sound' } } });
            options.body.query.filtered.filter.bool.must_not.push({ 'match_phrase_prefix': { 'genres.name': { 'query': 'Special' } } });
            options.body.sort = [
                {
                    "quality": {
                        "order": "desc"
                    }
                }
            ]; //sorting ...
        } else if (type === 'playlist') {
            if (typeof options.body.query.filtered.filter.bool === 'undefined') {
                options.body.query.filtered.filter.bool = {};
            }
            if (typeof options.body.query.filtered.filter.bool.must === 'undefined') {
                options.body.query.filtered.filter.bool.must = [];
            }
            // setting up sort order....

            options.body.sort = [{ 'id': { 'order': 'desc' , 'ignore_unmapped' : true} }, { 'visibility': { 'order': 'desc' , 'ignore_unmapped' : true} }];
    }

    if(type === 'liked-item') {
        options.body.fields = ['song_id'];
    }

    if(typeof q !== 'undefined' && q != null && q.length > 0) {
    // options.body.query.filtered.query = {
    //     'simple_query_string': {
    //         // 'query': q + '*',
    //         'query': q ,
    //         'flags': 'OR|AND|PREFIX'
    //     }
    // };
    let tmpCriteria = {
        'multi_match': {
            'query': q.toLowerCase(),
            'type': 'phrase_prefix',
            'fields': [
                'name',
                'artist.name',
                'album.name',
                'screenname',
                'slug',
                'title',
                'label',
                'taglist',
                'decade',
                'tempo',
                'lyrics',
                // 'pitch',
                'fullname',
                'firstname',
                'lastname'
            ]
        }
    };
    options.body.query.filtered.filter.bool.must.push(tmpCriteria);
}
return options;
    }

setCriteria(options, type, pageParams: any = false, searchQuery = null) {
    if (pageParams === false) {
        this.size = 20;
        this.from = 0;
    } else {
        this.size = pageParams.size;
        this.from = pageParams.size * (pageParams.page - 1);
    }
    let optionsObj = this.getSearchCriteriaByIndexType(type, searchQuery);
    _.each(options, function (v, k) {
        let term = { 'match': {} };
        term.match[k] = v;
        optionsObj.body.query.filtered.filter.bool.must.push(term);
    });
    return optionsObj;
}

listing(customOptions: any) {
    return this.search(customOptions);
}

getBasicSearchCriteria(query: string, searchCriteria: BasicSearchParams, pageParams: any = false) {
    //query = '*' + query + '*';
    let fields;
    if (searchCriteria.searchSongs === false || searchCriteria.searchLike === false  || searchCriteria.searchCredits === false  ){
        fields=[];
        fields.push('name');
        fields.push('slug');
        fields.push('title');
        fields.push('screenname');
        fields.push('fullname');
        fields.push('firstname');
        fields.push('lastname');
    }

    if (searchCriteria.searchSongs === true  ){
        fields=[];
        fields.push('name');
        fields.push('slug');
    }

    if (searchCriteria.searchLike === true  ){
        fields=[];
        fields.push('soundlike_name');
    }

    if (searchCriteria.searchCredits === true  ){
        fields=[];
        fields.push('credits_name');
    }
        let criteria: any = {
        index: 'newone_weget',
        size: 50,
        body: {
            'sort': [
               /* { 'name': { 'order': 'desc' } },
                { 'quality': { 'order': 'asc' } },*/
                /*{ '_score': { 'order': 'asc' } }*/
            ],
            'query': {
                'filtered': {
                    'query': {
                        'bool': {
                            'must': [
                                {
                                    'multi_match': {
                                        'query': query.toLowerCase(),
                                        'type': 'phrase_prefix',
                                        // 'type': 'phrase',
                                        "max_expansions" : 1000,
                                        'fields':fields
                                    }
                                }
                            ]
                        },
                    },
                    'filter': {
                        'bool': {
                            'must_not': [
                                { 'term': { 'is_searchable': '0' } },
                                { 'term': { 'active': '0' } },
                                { 'terms': { 'visibility': ['private', 'system'] } }
                            ],
                            'should': [
                                { 'type': { 'value': 'fakeType' } }
                            ]
                        }
                    }
                }
            }

        }
    };
    let searchAll = !(searchCriteria.searchArtists || searchCriteria.searchCollections ||
        searchCriteria.searchPlaylists || searchCriteria.searchSongs || searchCriteria.searchUsers || searchCriteria.searchLike || searchCriteria.searchCredits);


    if (searchCriteria.searchSongs === true || searchAll === true || searchCriteria.searchLike === true  || searchCriteria.searchCredits === true ) {
        criteria.body.query.filtered.filter.bool.should.push({ 'type': { 'value': 'song' } });
/*        criteria.body.query.filtered.filter.bool.must_not.push({ 'term': { 'pricing': 'A' } });
        criteria.body.query.filtered.filter.bool.must_not.push({ 'term': { 'active': '0' } });
        //criteria.body.query.filtered.filter.bool.must_not.push({ 'missing': { 'field': 'writers' } });
        criteria.body.query.filtered.filter.bool.must_not.push({ 'match_phrase_prefix': { 'genres.name': { 'query': 'Sound' } } });
        criteria.body.query.filtered.filter.bool.must_not.push({ 'match_phrase_prefix': { 'genres.name': { 'query': 'Special' } } });
        criteria.body.query.filtered.filter.bool.must_not.push({ 'range': { 'length': { 'lt': 120 } } });*/
    }
    if (searchCriteria.searchArtists || searchAll === true) {
        criteria.body.query.filtered.filter.bool.should.push({ 'type': { 'value': 'artist' } });
    }
    if (searchCriteria.searchCollections || searchAll === true) {
        criteria.body.query.filtered.filter.bool.should.push({ 'type': { 'value': 'album' } });
    }
    if (searchCriteria.searchPlaylists || searchAll === true) {
        criteria.body.query.filtered.filter.bool.should.push({ 'type': { 'value': 'playlist' } });
    }
    if (searchCriteria.searchUsers || searchAll === true) {
        criteria.body.query.filtered.filter.bool.should.push({ 'type': { 'value': 'account' } });
    }
    if (pageParams === false) {
        criteria.size = 20;
        criteria.from = 0;
    } else {
        criteria.size = pageParams.size;
        criteria.from = pageParams.size * (pageParams.page - 1);
    }
    return criteria;
}

    public getLikeByTypeCriteria(domain, object) {
        let searchParams = {
            index: 'newone_weget',
            type: 'like',
            body: {
                'query': {
                    'bool': {
                        'filter': [
                            { 'term': { 'is_liked': 1 } },
                            { 'term': { 'domain': domain } },
                            { 'term': { 'object': object } }
                        ]
                    }
                }
            }
        };
        return searchParams;
}

getUserLikeCount(searchParams: any) {
    return this.es.count(searchParams);
}

getUserLikes(searchParams: any) {
    return this.search(searchParams);
}

getUserFollowersCriteria(user) {
    let searchParams = {
        index: 'newone_weget',
        type: 'follower',
        body: {
            'query': {
                'bool': {
                    'filter': [
                        { 'term': { 'object': user } },
                        { 'term': { 'domain': 'u' } },
                        { 'term': { 'is_following': 1 } }
                    ]
                }
            }
        }
    };
    return searchParams;
}

getUserSongsQuota(userId) {
    let searchParams = {
        index: 'newone_weget',
        type: 'tracking',
        body: {
            'query': {
                'bool': {
                    'must': [
                        { 'match': { 'event_key': 'WG_SONG_PLAYED' } },
                        { 'match': { 'user_id': 99 } },
                        {
                            'range': {
                                'created_at': {

                                    'gte': 'now/d'
                                }
                            }
                        }
                    ]
                }
            }
        }
    };
    return this.es.count(searchParams);
}

setAdvancedSongsCriteria(options) {
    // var criteria = searchFactory.getSearchCriteriaByIndexType(searchFactory.getSearchTerm(), 'song');

    // if (typeof criteria.body.query.filtered.filter.bool == 'undefined') {
    //     criteria.body.query.filtered.filter.bool = {};
    // }

    // if (typeof criteria.body.query.filtered.filter.bool.should == 'undefined') {
    //     criteria.body.query.filtered.filter.bool.should = [];
    // }

    // if (typeof criteria.body.query.filtered.filter.bool.must == 'undefined') {
    //     criteria.body.query.filtered.filter.bool.must = [];
    // }
    // //convert all multi to array
    // var genres = null;
    // var instrument = [];
    // var decade = [];
    // var term = [];
    // _.each(options, function (v, k) {
    //     if (k == 'genres') {
    //         genres = v instanceof Array ? v : [v];
    //     }
    //     if (k == 'decade') {
    //         decade = v instanceof Array ? v : [v];
    //     }
    //     if (k == 'instruments') {
    //         instrument = v instanceof Array ? v : [v];
    //     }
    // });
    // //convert all multi to array
    // _.each(options, function (v, k) {
    //     if (k == 'genres') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             terms: {
    //                 'genres.genre_id': genres
    //             }
    //         });
    //     }
    //     if (k == 'instruments') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             terms: {
    //                 'instruments.instrument': instrument
    //             }
    //         });
    //     }
    //     if (k == 'decade') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             terms: {
    //                 'decade': _.map(decade, _.method('toLowerCase'))
    //             }
    //         });
    //     }
    //     if (k == 'minLength') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             'range': {
    //                 'length': {
    //                     'from': parseInt(options.minLength),
    //                     'to': parseInt(options.maxLength)
    //                 }
    //             }
    //         });
    //     }
    //     if (k == 'tempo') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             'term': {
    //                 'tempo': v
    //             }
    //         });
    //     }
    //     if (k == 'vocal_type') {
    //         criteria.body.query.filtered.filter.bool.must.push({
    //             'term': {
    //                 'vocal_type': v
    //             }
    //         });
    //     }
    // });
    // return criteria;
}

/* this effort is made because of sorting the position of ids a per returned, lodash returns wrong order */
fetchIds(hits) {
    let ids = new Array<any>();
    hits.forEach((arrayItem) => {
        ids.push(arrayItem._id);
    });
    return ids;

}

}



// WEBPACK FOOTER //
// ./src/app/api/services/es.service.ts